/* unplugin-vue-components disabled */import script from "./TaskIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskIcon.vue?vue&type=script&setup=true&lang=ts"

import "./TaskIcon.vue?vue&type=style&index=0&id=17e91788&lang=scss&scoped=true"
import "./TaskIcon.vue?vue&type=style&index=1&id=17e91788&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17e91788"]])

export default __exports__